export const WHATSAPP_URL =
  "https://api.whatsapp.com/send/?phone=918293273236&text&type=phone_number&app_absent=0";

type ClickEvent = {
  preventDefault: () => void;
  stopPropagation?: () => void;
  nativeEvent?: {
    stopImmediatePropagation?: () => void;
  };
};

export const openWhatsApp = (event?: ClickEvent) => {
  event?.preventDefault();
  event?.stopPropagation?.();
  event?.nativeEvent?.stopImmediatePropagation?.();

  window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer");
};